import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  text-align: center;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  h1 {
    margin-bottom: 0;
  }
`;
const PageNotFound = () => {
  return (
    <Wrapper>
      <div className="not-found-page">
        <h1>404</h1>
        <h3>Page not found.</h3>
        <p>The page you are looking for doesn't exist.</p>
      </div>
    </Wrapper>
  );
};

export default PageNotFound;
